function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTea(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M160-830v-.833h8.875v.833zm2.1-1.667a2.035 2.035 0 0 1-1.486-.6 2 2 0 0 1-.614-1.483V-840h9.167a.8.8 0 0 1 .589.245.8.8 0 0 1 .245.589v2.222a.8.8 0 0 1-.245.589.8.8 0 0 1-.589.245h-1.333v2.361a2 2 0 0 1-.611 1.479 2.035 2.035 0 0 1-1.486.6zm5.736-5.278h1.333v-2.222h-1.333z",
    transform: "translate(-160 840)",
    style: {
      fill: "#196cca"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTea);
export default __webpack_public_path__ + "static/media/tea.28b88c152b9458e340f4f67d2b7bed31.svg";
export { ForwardRef as ReactComponent };